export const DEFAULT_ADD_MULTIPLE_TO_CART = {
  active: false,
  isBundle: false,
};
